import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import auth from './common/auth'
import VueClipboard from 'vue-clipboard2'
import '@fortawesome/fontawesome-free/css/all.css'

// 将auth模块添加到Vue原型中，使其在所有组件中可用
Vue.prototype.$auth = auth

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
